import React, { useEffect, useState } from "react";
import classNames from 'classnames';

interface Props {
  visibleLicenseTypes: string[];
  licenseText: {
    desktop: string;
    web: string;
    app: string;
  };
  handleTypeChange?: (type: string) => void;
  selectedLicenseType?: string;
  scrollRef?: React.RefObject<HTMLDivElement>;
  children?: React.ReactNode;
}

const FontLicensingLicense: React.FC<Props> = (props) => {
  const [selectedType, setSelectedType] = useState<string>(
    props.selectedLicenseType || props.visibleLicenseTypes[0]
  );
  const [licenseText, setLicenseText] = useState({
    __html: props.licenseText[selectedType]
  });

  // Default type selection handler, can be overridden by
  // props.handleTypeChange.
  const selectType = (selectedType: string) => {
    setSelectedType(selectedType);
    props.scrollRef?.current?.scrollTo(0, 0);
  };

  const renderTabs = () => {
    return props.visibleLicenseTypes.map((type) => {
      return (
        <Tab
          key={type}
          type={type}
          selectedType={selectedType}
          onSelect={props.handleTypeChange || selectType}
        />
      );
    });
  }

  // Sync selectedType with props.selectedLicenseType if it changes.
  useEffect(() => {
    if (props.selectedLicenseType) {
      selectType(props.selectedLicenseType);
    }
  }, [props.selectedLicenseType]);

  // Update license text when selectedType changes.
  useEffect(() => {
    setLicenseText({
      __html: props.licenseText[selectedType]
    });
  }, [selectedType]);

  return (
    <div className="FontLicensingLicenses">
      <div className="license-navigation">{renderTabs()}</div>

      <div className="license-box">
        <div className="license-scroll-header">
          Please scroll to review &amp; confirm your agreement
        </div>

        <div ref={props.scrollRef} className="license-scroll">
          <div className="license-text" dangerouslySetInnerHTML={licenseText} />
        </div>

        {props.children}
      </div>
    </div>
  );
}

const Tab: React.FC<{
  type: string;
  selectedType: string;
  onSelect(selectedType: string): void;
}> = (props) => {
  const { type, selectedType, onSelect } = props;

  const classes = classNames('license-navigation-item', {
    active: type === selectedType
  });

  return (
    <a className={classes} onClick={onSelect.bind(null, type)}>
      {type}
    </a>
  );
};

export default FontLicensingLicense;
